import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const GroupManagementLink = (_context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.groups_management',
    link: '/groups/list/groups',
    icon: 'navigation-link__list-item',
});